import { render, staticRenderFns } from "./ChecklistContact.vue?vue&type=template&id=1dc82bdc&"
import script from "./ChecklistContact.vue?vue&type=script&lang=js&"
export * from "./ChecklistContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports